/* Modish wishlist: saved on this device (localStorage) */
(function () {
  var KEY = 'md_wishlist_v1';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} sync(); document.dispatchEvent(new CustomEvent('md:wishlist')); }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) {
    var l = read(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.unshift(h);
    write(l);
    return i === -1;
  }
  function sync() {
    var l = read();
    document.querySelectorAll('[data-md-wl]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-md-wl')) > -1;
      if (b.classList.contains('is-saved') !== on) b.classList.toggle('is-saved', on);
      var ap = on ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== ap) b.setAttribute('aria-pressed', ap);
      var lab = b.querySelector('.md-wl-btn__label'), txt = on ? 'Saved to wishlist' : 'Save to wishlist';
      if (lab && lab.textContent !== txt) lab.textContent = txt;
    });
    var n = l.length ? String(l.length) : '';
    document.querySelectorAll('.md-wl-count').forEach(function (c) { if (c.textContent !== n) c.textContent = n; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-md-wl]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    toggle(b.getAttribute('data-md-wl'));
  }, true);
  window.mdWishlist = { read: read, write: write, toggle: toggle, sync: sync };
  document.addEventListener('DOMContentLoaded', sync);
  var pending = false;
  new MutationObserver(function (m) {
    if (pending) return;
    for (var i = 0; i < m.length; i++) {
      var a = m[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        if (a[j].nodeType === 1 && (a[j].matches('[data-md-wl]') || a[j].querySelector('[data-md-wl]'))) {
          pending = true; setTimeout(function () { pending = false; sync(); }, 50); return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
})();
